import React from "react";
import { Routes, Route } from "react-router-dom";
import Filling from "../layout/filling/Filling";
import AddFilling from "../layout/filling/AddFilling";
import FillingForm from "../layout/filling/FillingForm";


const FillingPage = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Filling />} />
        <Route path="/add" element={<AddFilling />} />
        <Route path="/update/:id" element={<AddFilling />} />
        <Route path="/specification/:id" element={<FillingForm />} />
      </Routes>
    </>
  );
};

export default FillingPage;
